"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowPluginRoutes = void 0;
const react_1 = __importStar(require("react"));
const Workflow_context_1 = require("../Workflow.context");
/**
 * Render Workflow plugin `routes` components.
 */
const WorkflowPluginRoutes = () => {
    const { servicePlugins } = (0, Workflow_context_1.useWorkflowContext)();
    return (react_1.default.createElement(react_1.default.Fragment, null, servicePlugins.map((plugin, index) => (react_1.default.createElement(react_1.Fragment, { key: `${plugin.src}-${index}` }, plugin.routes && react_1.default.createElement(plugin.routes, null))))));
};
exports.WorkflowPluginRoutes = WorkflowPluginRoutes;
exports.default = exports.WorkflowPluginRoutes;
//# sourceMappingURL=WorkflowPluginRoutes.js.map